import React from 'react';

const MobileTable = () => (
  <div className="tablet-hidden desktop-hidden">
    <table className="upgrade-plan-table">
      <tbody>
        <tr className="placeholder-row">
          {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
          <th />
          {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
          <th />
          <th className="table-header table-header__annual annual-border">
            <img
              src="https://s3.amazonaws.com/dev-abtesting-assets/upgrade plancomp/images/best-value-mobile.svg"
              alt="best value"
            />
          </th>
        </tr>
        <tr>
          <th className="table-header__feature table-header">Feature</th>
          <th className="table-header__seasonal table-header border-right-none">Seasonal</th>
          <th className="table-header table-header__annual annual-border">Annual</th>
        </tr>
        <tr className="feature-row">
          <th className="table-features">Early access to sales</th>
          <td><i className="far fa-times times-icon" /></td>
          <td className="annual-side-border"><i className="far fa-check check-icon" /></td>
        </tr>
        <tr className="table-divider" />
        <tr className="feature-row">
          <th className="table-features">More box customization</th>
          <td><i className="far fa-times times-icon" /></td>
          <td className="annual-side-border"><i className="far fa-check check-icon" /></td>
        </tr>
        <tr className="table-divider" />
        <tr className="feature-row">
          <th className="table-features">Earlier shipping</th>
          <td><i className="far fa-times times-icon" /></td>
          <td className="annual-side-border"><i className="far fa-check check-icon" /></td>
        </tr>
        <tr className="table-divider" />
        <tr className="feature-row">
          <th className="table-features">$200+ value per box</th>
          <td><i className="far fa-check check-icon" /></td>
          <td className="annual-side-border"><i className="far fa-check check-icon" /></td>
        </tr>
        <tr className="table-divider" />
        <tr className="feature-row">
          <th className="table-features">Customize Your Box</th>
          <td><i className="far fa-check check-icon" /></td>
          <td className="annual-side-border"><i className="far fa-check check-icon" /></td>
        </tr>
        <tr className="table-divider" />
        <tr className="feature-row">
          <th className="table-features">Members Only Sales</th>
          <td><i className="far fa-check check-icon" /></td>
          <td className="annual-side-border annual-bottom-border"><i className="far fa-check check-icon" /></td>
        </tr>
        <tr className="table-divider" />
      </tbody>
    </table>
  </div>
);

export default MobileTable;
